// client/src/components/indicadores/ProdutosReport.js
import React, { useState, useEffect } from 'react';
import useAlert from '../../hooks/useAlert';
import { useProdutosReport } from '../../hooks/useReports'; // ✅ HOOK CORRETO
import { useTenantI18n } from '../../hooks/useAccounts';
import { formatCurrency } from '../../utils/formatters';
import PageHeader from '../layout/PageHeader';
import { ShoppingCart, Filter as FilterIcon } from 'lucide-react';
import ReportTable from './ReportTable';
import FilterBar from './FilterBar';

// ✅ DEFINIR FILTROS INICIAIS
const initialFilters = {
    startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    endDate: new Date(),
};

const ProdutosReport = () => {
    const { setAlert } = useAlert();
    // ✅ ACHADO: fixo em BRL, sem ler configuracoesGerais.i18n da conta.
    const { currency, locale } = useTenantI18n();

    const [filters, setFilters] = useState(initialFilters);
    const [appliedFilters, setAppliedFilters] = useState(initialFilters);
    const [showFilters, setShowFilters] = useState(false);

    // ✅ USANDO O NOVO HOOK
    const { data: reportData = [], isLoading, error } = useProdutosReport(appliedFilters);

    // ✅ TRATAMENTO DE ERRO
    useEffect(() => {
        if (error) {
            const errorMessage = error.message || 'Ocorreu um erro ao buscar o relatório.';
            setAlert(errorMessage, 'danger');
        }
    }, [error, setAlert]);

    const handleApplyFilters = () => {
        setAppliedFilters(filters);
        setShowFilters(false);
    };

    const handleClearFilters = () => {
        setFilters(initialFilters);
        setAppliedFilters(initialFilters);
    };

    const columns = [
        { key: 'nome', header: 'Produto / Item de Venda', render: (row) => row._id },
        { key: 'quantidade', header: 'Quantidade Vendida', render: (row) => row.quantidadeVendida },
        { key: 'faturamento', header: 'Faturamento Total', render: (row) => formatCurrency(row.faturamentoTotal || 0, currency, locale) },
    ];

    const pageActions = (
        <button 
            onClick={() => setShowFilters(prevState => !prevState)} 
            className="action-button action-button-secondary"
        >
            <FilterIcon size={18} className="icon"/> 
            {showFilters ? 'Ocultar Filtros' : 'Exibir Filtros'}
        </button>
    );

    return (
        <div className="page-management-container report-page">
            <PageHeader
                icon={<ShoppingCart size={24} />}
                title="Relatório de Produtos" 
                actions={pageActions} 
            />

            {showFilters && (
                <div className="content-panel">
                    <h3 className="panel-title">Filtros</h3>
                    <FilterBar 
                        filters={filters}
                        setFilters={setFilters}
                        onApply={handleApplyFilters}
                        onClear={handleClearFilters}
                        options={{}}
                        enabledFilters={['date']}
                        isLoading={isLoading}
                    />
                </div>
            )}
            
            <div className="table-container" style={{ marginTop: '1.5rem' }}>
                <ReportTable 
                    title="Produtos Mais Vendidos" 
                    columns={columns} 
                    data={reportData} // ✅ USANDO DATA DO HOOK
                    isLoading={isLoading} 
                />
            </div>
        </div>
    );
};

export default ProdutosReport;